var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListTitleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6364 14.0909V12.6364C11.6364 11.0297 10.3339 9.72729 8.72727 9.72729H2.90909C1.30244 9.72729 0 11.0297 0 12.6364V14.0909",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81827 6.81818C7.42492 6.81818 8.72736 5.51574 8.72736 3.90909C8.72736 2.30244 7.42492 1 5.81827 1C4.21162 1 2.90918 2.30244 2.90918 3.90909C2.90918 5.51574 4.21162 6.81818 5.81827 6.81818Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 14.0909V12.6364C15.9992 11.3107 15.102 10.1533 13.8184 9.82184",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9092 1.09454C12.1964 1.42412 13.0967 2.58399 13.0967 3.91273C13.0967 5.24146 12.1964 6.40133 10.9092 6.73091",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListTitleIcon);
export default __webpack_public_path__ + "static/media/list-title-icon.e289fa08.svg";
export { ForwardRef as ReactComponent };